import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, typography, spacing, radius, focusVisible, sizing } from '@/styles/designTokens'

export const CartButtonRoot = styled('button')(({ theme }) => ({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'relative',
	flexShrink: 0,
	width: sizing.buttonHeight,
	height: sizing.buttonHeight,
	padding: spacing.sm,
	borderRadius: radius.circle,
	border: `1px solid ${colors.border}`,
	backgroundColor: colors.surfaceWhite,
	cursor: 'pointer',
	'&:focus-visible': {
		outline: `${focusVisible.outline} ${colors.overlayHeavy}`,
		outlineOffset: focusVisible.outlineOffset,
	},
	// Hidden only at full desktop (≥1025px) where CartSidebar takes over.
	[theme.breakpoints.up('lg')]: { display: 'none' },
}))

export const CartBadge = styled(Box)({
	position: 'absolute',
	top: 0,
	right: 0,
	minWidth: 18,
	height: 18,
	borderRadius: radius.circle,
	backgroundColor: colors.brand,
	color: colors.textInverse,
	fontSize: typography.fontSizeXs,
	fontWeight: typography.fontWeightBold,
	fontFamily: typography.fontFamily,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	lineHeight: 1,
	paddingLeft: spacing.xxs,
	paddingRight: spacing.xxs,
})
